import { useEffect } from "react";
// import { withRouter } from "react-router-dom";
import { useLocation } from "react-router-dom";
import Header from "../Component/Header";
import Footer from "../Component/Footer";
import {
  ADD_BUSINESS_DETAILS,
  ALLREVIEWS,
  CHAT,
  CREATE_NEW_PASSWORD,
  FORGOT_PASSWORD,
  LOGIN,
  REGISTER,
  SIGNIN,
  SIGNINOTP,
} from "./RoutesConstant";
import { useSelector, useDispatch } from "react-redux";
import { logout } from "../Redux/Action/LoginAction/loginAction";
import { useNavigate } from "react-router-dom";

const ScrollToTop = ({ children }) => {
  const { pathname } = useLocation();
  const { setShow } = useSelector((state) => state.locationReducer);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const routes = [SIGNIN, SIGNINOTP, LOGIN, REGISTER, ALLREVIEWS];
  // const showState = locationData.setShow;
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
    // Auto logout if navigating to /signin (but not /login to avoid refresh loop)
    if (pathname === SIGNIN) {
      dispatch(logout());
      // navigate(LOGIN, { replace: true });
    }
  }, [pathname, dispatch, navigate]);
  return (
    <>
      {( !pathname.includes(LOGIN) &&
          !pathname.includes(REGISTER) && 
          !pathname.includes(SIGNIN) &&
          !pathname.includes(SIGNINOTP) &&
          !pathname.includes(FORGOT_PASSWORD) &&
          !pathname.includes(CREATE_NEW_PASSWORD) ) ? (
        <Header showState={setShow} loginShow={true} />
      ) : (
        <Header showState={false} loginShow={false} />
      )}
      <div className={ "body_wrapper"}>
        {children || null}
        {pathname !== ALLREVIEWS &&
          !pathname.includes(LOGIN) &&
          !pathname.includes(REGISTER) && 
          !pathname.includes(SIGNIN) &&
          !pathname.includes(SIGNINOTP) &&
          !pathname.includes(FORGOT_PASSWORD) &&
          !pathname.includes(CHAT) &&
          !pathname.includes(CREATE_NEW_PASSWORD) &&
          <Footer showDownload={!pathname.includes(ADD_BUSINESS_DETAILS)} />}
      </div>
    </>
  );
};

export default ScrollToTop;
